import React from "react";

import { Outlet, RouterProvider, createBrowserRouter } from "react-router-dom";

import { publicRoutes } from "./routes";
import { PageLayout } from "components/page-layout";

export function PublicRouter() {
  const publicRouter = createBrowserRouter([
    {
      element: (
        <PageLayout>
          <Outlet />
        </PageLayout>
      ),
      children: publicRoutes,
    },
  ]);

  return <RouterProvider router={publicRouter} />;
}
